/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

import { getGenderLabelByKey } from '../api/request'

const topSearchHeading = {
    defaultSuggestionsHeading: null,
    fallbackSuggestionsHeadingTemplate: null,
    suggestionsHeading: '',
    defaultProductSuggestionsHeading: null,
    fallbackProductSuggestionsHeadingTemplate: null,
    productSuggestionsHeading: '',
    isFallbackSuggestionsHeadingActive: false,
    /**
     * Initialize heading defaults from translations
     */
    initHeadingDefaults() {
        if (this.defaultSuggestionsHeading !== null && this.defaultProductSuggestionsHeading !== null) {
            return
        }

        const translations = window.liveSearchConfig?.translations ?? {}

        this.defaultSuggestionsHeading = translations.searchSuggestions || 'Search suggestions'
        this.fallbackSuggestionsHeadingTemplate = translations.searchSuggestionsIn || ''
        this.defaultProductSuggestionsHeading = translations.productSuggestions || 'Product suggestions'
        this.fallbackProductSuggestionsHeadingTemplate = translations.productSuggestionsIn || ''
        this.suggestionsHeading = this.defaultSuggestionsHeading
        this.productSuggestionsHeading = this.defaultProductSuggestionsHeading
    },
    /**
     * Update headings depending on fallback state
     *
     * @param {Object} genderOutcome
     */
    updateSuggestionsHeading(genderOutcome) {
        this.initHeadingDefaults()

        if (genderOutcome?.usedGenderKey) {
            const label = getGenderLabelByKey(genderOutcome.usedGenderKey)
            if (!label) {
                this.resetSuggestionsHeading()
                return
            }

            this.suggestionsHeading = this.getFallbackHeading(
                this.fallbackSuggestionsHeadingTemplate,
                this.defaultSuggestionsHeading,
                label
            )
            this.productSuggestionsHeading = this.getFallbackHeading(
                this.fallbackProductSuggestionsHeadingTemplate,
                this.defaultProductSuggestionsHeading,
                label
            )
            this.isFallbackSuggestionsHeadingActive = Boolean(genderOutcome?.fallbackTriggered)
            return
        }

        this.resetSuggestionsHeading()
    },
    /**
     * Build fallback heading from template, default and gender label
     *
     * @param {string} template
     * @param {string} defaultHeading
     * @param {string} genderLabel
     * @returns {string}
     */
    getFallbackHeading(template, defaultHeading, genderLabel) {
        this.initHeadingDefaults()

        const resolvedTemplate = template || `${defaultHeading} (%1)`

        return resolvedTemplate.includes('%1')
            ? resolvedTemplate.replace('%1', genderLabel)
            : `${resolvedTemplate} ${genderLabel}`
    },
    /**
     * Reset suggestion headings to default state
     */
    resetSuggestionsHeading() {
        this.initHeadingDefaults()
        this.suggestionsHeading = this.defaultSuggestionsHeading
        this.productSuggestionsHeading = this.defaultProductSuggestionsHeading
        this.isFallbackSuggestionsHeadingActive = false
    }
}

export default topSearchHeading
